export const legendGradients = {
    hail: ['#ffffff00', '#ffa0cf96', '#d96ea3ff', '#c04d86ff', '#ae3370ff', '#920d4fff'],
    rainfalls: [
        '#ffffff00',
        '#e7f1fa96',
        '#c9def0ff',
        '#9cc8e1ff',
        '#6daed5ff',
        '#3d8cc3ff',
        '#1c69aeff',
        '#083b7cff',
        '#26087cff',
        '#3f0dcdff',
        '#250a7bff'
    ]
};
/** Number of ms between two steps when the slider is autoplaying */
export const sliderMsBetweenSteps = 800;
export const radarRainfallsItems = ['light_mist', 'moderate', 'heavy'];
export const radarHailItems = ['hardly_noticeable', 'moderate', 'hard_hail'];
